/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PathlessLayoutRouteImport } from './routes/_pathlessLayout'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PathlessLayoutMfaRouteImport } from './routes/_pathlessLayout/mfa'
import { Route as AuthenticatedSupportIndexRouteImport } from './routes/_authenticated/support/index'
import { Route as AuthenticatedProfileIndexRouteImport } from './routes/_authenticated/profile/index'
import { Route as AuthenticatedHomeIndexRouteImport } from './routes/_authenticated/home/index'
import { Route as AuthenticatedBillingIndexRouteImport } from './routes/_authenticated/billing/index'
import { Route as AuthenticatedSupportReportFaultRouteImport } from './routes/_authenticated/support/report-fault'
import { Route as AuthenticatedSupportNewComplaintRouteImport } from './routes/_authenticated/support/new-complaint'
import { Route as AuthenticatedServiceServiceTestsRouteImport } from './routes/_authenticated/service/service-tests'
import { Route as AuthenticatedServiceResultRouteImport } from './routes/_authenticated/service/result'
import { Route as AuthenticatedProfileEditRouteImport } from './routes/_authenticated/profile/edit'
import { Route as AuthenticatedHomeUsageRouteImport } from './routes/_authenticated/home/usage'
import { Route as AuthenticatedHomePlanRouteImport } from './routes/_authenticated/home/plan'
import { Route as AuthenticatedHomeOutagesRouteImport } from './routes/_authenticated/home/outages'
import { Route as AuthenticatedBillingPaymentDetailsRouteImport } from './routes/_authenticated/billing/payment-details'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PathlessLayoutRoute = PathlessLayoutRouteImport.update({
  id: '/_pathlessLayout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PathlessLayoutMfaRoute = PathlessLayoutMfaRouteImport.update({
  id: '/mfa',
  path: '/mfa',
  getParentRoute: () => PathlessLayoutRoute,
} as any)
const AuthenticatedSupportIndexRoute =
  AuthenticatedSupportIndexRouteImport.update({
    id: '/support/',
    path: '/support/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileIndexRoute =
  AuthenticatedProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHomeIndexRoute = AuthenticatedHomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBillingIndexRoute =
  AuthenticatedBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSupportReportFaultRoute =
  AuthenticatedSupportReportFaultRouteImport.update({
    id: '/support/report-fault',
    path: '/support/report-fault',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSupportNewComplaintRoute =
  AuthenticatedSupportNewComplaintRouteImport.update({
    id: '/support/new-complaint',
    path: '/support/new-complaint',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedServiceServiceTestsRoute =
  AuthenticatedServiceServiceTestsRouteImport.update({
    id: '/service/service-tests',
    path: '/service/service-tests',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedServiceResultRoute =
  AuthenticatedServiceResultRouteImport.update({
    id: '/service/result',
    path: '/service/result',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileEditRoute =
  AuthenticatedProfileEditRouteImport.update({
    id: '/profile/edit',
    path: '/profile/edit',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHomeUsageRoute = AuthenticatedHomeUsageRouteImport.update({
  id: '/home/usage',
  path: '/home/usage',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHomePlanRoute = AuthenticatedHomePlanRouteImport.update({
  id: '/home/plan',
  path: '/home/plan',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHomeOutagesRoute =
  AuthenticatedHomeOutagesRouteImport.update({
    id: '/home/outages',
    path: '/home/outages',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBillingPaymentDetailsRoute =
  AuthenticatedBillingPaymentDetailsRouteImport.update({
    id: '/billing/payment-details',
    path: '/billing/payment-details',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/mfa': typeof PathlessLayoutMfaRoute
  '/billing/payment-details': typeof AuthenticatedBillingPaymentDetailsRoute
  '/home/outages': typeof AuthenticatedHomeOutagesRoute
  '/home/plan': typeof AuthenticatedHomePlanRoute
  '/home/usage': typeof AuthenticatedHomeUsageRoute
  '/profile/edit': typeof AuthenticatedProfileEditRoute
  '/service/result': typeof AuthenticatedServiceResultRoute
  '/service/service-tests': typeof AuthenticatedServiceServiceTestsRoute
  '/support/new-complaint': typeof AuthenticatedSupportNewComplaintRoute
  '/support/report-fault': typeof AuthenticatedSupportReportFaultRoute
  '/billing': typeof AuthenticatedBillingIndexRoute
  '/home': typeof AuthenticatedHomeIndexRoute
  '/profile': typeof AuthenticatedProfileIndexRoute
  '/support': typeof AuthenticatedSupportIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/mfa': typeof PathlessLayoutMfaRoute
  '/billing/payment-details': typeof AuthenticatedBillingPaymentDetailsRoute
  '/home/outages': typeof AuthenticatedHomeOutagesRoute
  '/home/plan': typeof AuthenticatedHomePlanRoute
  '/home/usage': typeof AuthenticatedHomeUsageRoute
  '/profile/edit': typeof AuthenticatedProfileEditRoute
  '/service/result': typeof AuthenticatedServiceResultRoute
  '/service/service-tests': typeof AuthenticatedServiceServiceTestsRoute
  '/support/new-complaint': typeof AuthenticatedSupportNewComplaintRoute
  '/support/report-fault': typeof AuthenticatedSupportReportFaultRoute
  '/billing': typeof AuthenticatedBillingIndexRoute
  '/home': typeof AuthenticatedHomeIndexRoute
  '/profile': typeof AuthenticatedProfileIndexRoute
  '/support': typeof AuthenticatedSupportIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_pathlessLayout': typeof PathlessLayoutRouteWithChildren
  '/login': typeof LoginRoute
  '/_pathlessLayout/mfa': typeof PathlessLayoutMfaRoute
  '/_authenticated/billing/payment-details': typeof AuthenticatedBillingPaymentDetailsRoute
  '/_authenticated/home/outages': typeof AuthenticatedHomeOutagesRoute
  '/_authenticated/home/plan': typeof AuthenticatedHomePlanRoute
  '/_authenticated/home/usage': typeof AuthenticatedHomeUsageRoute
  '/_authenticated/profile/edit': typeof AuthenticatedProfileEditRoute
  '/_authenticated/service/result': typeof AuthenticatedServiceResultRoute
  '/_authenticated/service/service-tests': typeof AuthenticatedServiceServiceTestsRoute
  '/_authenticated/support/new-complaint': typeof AuthenticatedSupportNewComplaintRoute
  '/_authenticated/support/report-fault': typeof AuthenticatedSupportReportFaultRoute
  '/_authenticated/billing/': typeof AuthenticatedBillingIndexRoute
  '/_authenticated/home/': typeof AuthenticatedHomeIndexRoute
  '/_authenticated/profile/': typeof AuthenticatedProfileIndexRoute
  '/_authenticated/support/': typeof AuthenticatedSupportIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/mfa'
    | '/billing/payment-details'
    | '/home/outages'
    | '/home/plan'
    | '/home/usage'
    | '/profile/edit'
    | '/service/result'
    | '/service/service-tests'
    | '/support/new-complaint'
    | '/support/report-fault'
    | '/billing'
    | '/home'
    | '/profile'
    | '/support'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/mfa'
    | '/billing/payment-details'
    | '/home/outages'
    | '/home/plan'
    | '/home/usage'
    | '/profile/edit'
    | '/service/result'
    | '/service/service-tests'
    | '/support/new-complaint'
    | '/support/report-fault'
    | '/billing'
    | '/home'
    | '/profile'
    | '/support'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_pathlessLayout'
    | '/login'
    | '/_pathlessLayout/mfa'
    | '/_authenticated/billing/payment-details'
    | '/_authenticated/home/outages'
    | '/_authenticated/home/plan'
    | '/_authenticated/home/usage'
    | '/_authenticated/profile/edit'
    | '/_authenticated/service/result'
    | '/_authenticated/service/service-tests'
    | '/_authenticated/support/new-complaint'
    | '/_authenticated/support/report-fault'
    | '/_authenticated/billing/'
    | '/_authenticated/home/'
    | '/_authenticated/profile/'
    | '/_authenticated/support/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PathlessLayoutRoute: typeof PathlessLayoutRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_pathlessLayout': {
      id: '/_pathlessLayout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PathlessLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_pathlessLayout/mfa': {
      id: '/_pathlessLayout/mfa'
      path: '/mfa'
      fullPath: '/mfa'
      preLoaderRoute: typeof PathlessLayoutMfaRouteImport
      parentRoute: typeof PathlessLayoutRoute
    }
    '/_authenticated/support/': {
      id: '/_authenticated/support/'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthenticatedSupportIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/': {
      id: '/_authenticated/profile/'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home/': {
      id: '/_authenticated/home/'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedHomeIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/billing/': {
      id: '/_authenticated/billing/'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AuthenticatedBillingIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/support/report-fault': {
      id: '/_authenticated/support/report-fault'
      path: '/support/report-fault'
      fullPath: '/support/report-fault'
      preLoaderRoute: typeof AuthenticatedSupportReportFaultRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/support/new-complaint': {
      id: '/_authenticated/support/new-complaint'
      path: '/support/new-complaint'
      fullPath: '/support/new-complaint'
      preLoaderRoute: typeof AuthenticatedSupportNewComplaintRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/service/service-tests': {
      id: '/_authenticated/service/service-tests'
      path: '/service/service-tests'
      fullPath: '/service/service-tests'
      preLoaderRoute: typeof AuthenticatedServiceServiceTestsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/service/result': {
      id: '/_authenticated/service/result'
      path: '/service/result'
      fullPath: '/service/result'
      preLoaderRoute: typeof AuthenticatedServiceResultRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile/edit': {
      id: '/_authenticated/profile/edit'
      path: '/profile/edit'
      fullPath: '/profile/edit'
      preLoaderRoute: typeof AuthenticatedProfileEditRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home/usage': {
      id: '/_authenticated/home/usage'
      path: '/home/usage'
      fullPath: '/home/usage'
      preLoaderRoute: typeof AuthenticatedHomeUsageRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home/plan': {
      id: '/_authenticated/home/plan'
      path: '/home/plan'
      fullPath: '/home/plan'
      preLoaderRoute: typeof AuthenticatedHomePlanRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home/outages': {
      id: '/_authenticated/home/outages'
      path: '/home/outages'
      fullPath: '/home/outages'
      preLoaderRoute: typeof AuthenticatedHomeOutagesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/billing/payment-details': {
      id: '/_authenticated/billing/payment-details'
      path: '/billing/payment-details'
      fullPath: '/billing/payment-details'
      preLoaderRoute: typeof AuthenticatedBillingPaymentDetailsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedBillingPaymentDetailsRoute: typeof AuthenticatedBillingPaymentDetailsRoute
  AuthenticatedHomeOutagesRoute: typeof AuthenticatedHomeOutagesRoute
  AuthenticatedHomePlanRoute: typeof AuthenticatedHomePlanRoute
  AuthenticatedHomeUsageRoute: typeof AuthenticatedHomeUsageRoute
  AuthenticatedProfileEditRoute: typeof AuthenticatedProfileEditRoute
  AuthenticatedServiceResultRoute: typeof AuthenticatedServiceResultRoute
  AuthenticatedServiceServiceTestsRoute: typeof AuthenticatedServiceServiceTestsRoute
  AuthenticatedSupportNewComplaintRoute: typeof AuthenticatedSupportNewComplaintRoute
  AuthenticatedSupportReportFaultRoute: typeof AuthenticatedSupportReportFaultRoute
  AuthenticatedBillingIndexRoute: typeof AuthenticatedBillingIndexRoute
  AuthenticatedHomeIndexRoute: typeof AuthenticatedHomeIndexRoute
  AuthenticatedProfileIndexRoute: typeof AuthenticatedProfileIndexRoute
  AuthenticatedSupportIndexRoute: typeof AuthenticatedSupportIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedBillingPaymentDetailsRoute:
    AuthenticatedBillingPaymentDetailsRoute,
  AuthenticatedHomeOutagesRoute: AuthenticatedHomeOutagesRoute,
  AuthenticatedHomePlanRoute: AuthenticatedHomePlanRoute,
  AuthenticatedHomeUsageRoute: AuthenticatedHomeUsageRoute,
  AuthenticatedProfileEditRoute: AuthenticatedProfileEditRoute,
  AuthenticatedServiceResultRoute: AuthenticatedServiceResultRoute,
  AuthenticatedServiceServiceTestsRoute: AuthenticatedServiceServiceTestsRoute,
  AuthenticatedSupportNewComplaintRoute: AuthenticatedSupportNewComplaintRoute,
  AuthenticatedSupportReportFaultRoute: AuthenticatedSupportReportFaultRoute,
  AuthenticatedBillingIndexRoute: AuthenticatedBillingIndexRoute,
  AuthenticatedHomeIndexRoute: AuthenticatedHomeIndexRoute,
  AuthenticatedProfileIndexRoute: AuthenticatedProfileIndexRoute,
  AuthenticatedSupportIndexRoute: AuthenticatedSupportIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PathlessLayoutRouteChildren {
  PathlessLayoutMfaRoute: typeof PathlessLayoutMfaRoute
}

const PathlessLayoutRouteChildren: PathlessLayoutRouteChildren = {
  PathlessLayoutMfaRoute: PathlessLayoutMfaRoute,
}

const PathlessLayoutRouteWithChildren = PathlessLayoutRoute._addFileChildren(
  PathlessLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PathlessLayoutRoute: PathlessLayoutRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
